<div class="container-fluid">
	<div class="row align-items-center">
		<div class="col-10">
			<h1 class="text-capitalize my-3">
				{{purchase_info.purchase.id ? 'Actualizar':'Agregar'}} Orden de Compra
				<b>{{ purchase_info.purchase.id ? '#'+purchase_info.purchase.id : ''}}</b>
			</h1>
		</div>
		<div class="col-2">
			<button type="button" class="btn btn-secondary" (click)="print($event)" *ngIf="purchase_info.purchase.id">
				<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path fill="currentColor" d="M18 7H6V4q0-.425.287-.713Q6.575 3 7 3h10q.425 0 .712.287Q18 3.575 18 4Zm0 5.5q.425 0 .712-.288q.288-.287.288-.712t-.288-.713Q18.425 10.5 18 10.5t-.712.287Q17 11.075 17 11.5t.288.712q.287.288.712.288ZM8 19h8v-4H8v4Zm0 2q-.825 0-1.412-.587Q6 19.825 6 19v-2H3q-.425 0-.712-.288Q2 16.425 2 16v-5q0-1.275.875-2.137Q3.75 8 5 8h14q1.275 0 2.138.863Q22 9.725 22 11v5q0 .425-.288.712Q21.425 17 21 17h-3v2q0 .825-.587 1.413Q16.825 21 16 21Z"/></svg>
			</button>
		</div>
	</div>
	<form (submit)="save()" ngNativeValidate>
		<div class="card p-3" *ngIf="purchase_info">
			<div class="row">
				<div class="col-12 col-md-6 col-lg-3 dropdown">
					<label class="">Proveedor</label>
					<div class="input-group">
						<input type="text" name="provider_name" [ngModel]="purchase_info.purchase.provider_name" (ngModelChange)="searchProvider($event)" class="form-control" [disabled]="purchase_info.purchase.stock_status!='PENDING' || purchase_info.bank_movements_info.length > 0" required>
						<button type="button" class="btn btn-secondary" (click)="showChangeProviderModal()" *ngIf="rest.current_permission.add_providers && purchase_info.purchase.id" title="Cambiar Proveedor">
							<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" d="M12 20q-3.35 0-5.675-2.325T4 12t2.325-5.675T12 4q1.725 0 3.3.712T18 6.75V4h2v7h-7V9h4.2q-.8-1.4-2.187-2.2T12 6Q9.5 6 7.75 7.75T6 12t1.75 4.25T12 18q1.925 0 3.475-1.1T17.65 14h2.1q-.7 2.65-2.85 4.325T12 20"/></svg>
						</button>
					</div>
					<ul *ngIf="show_provider_list" class="dropdown-menu show">
						<li *ngIf="purchase_info.purchase.provider_name && rest.current_permission.add_providers" (click)="addNewProvider(purchase_info.purchase.provider_name)">
							<button type="button" class="dropdown-item">Registrar Proveedor</button>
						</li>
						<li *ngFor="let user of provider_user_list" (click)="userProviderSelected(user)">
							<span class="dropdown-item">{{user.id}} - {{user.name | titlecase}}</span>
						</li>
					</ul>
				</div>
				<div class="col-12 col-md-6 col-lg-3">
					<label>Sucursal</label>
					<select name="store_id" [(ngModel)]="purchase_info.purchase.store_id" class="form-control" [disabled]="purchase_info.purchase.stock_status!='PENDING' || purchase_info.bank_movements_info.length > 0" *ngIf="rest.current_permission.global_purchases">
						<option [ngValue]="null">Seleccione una opción</option>
						<option *ngFor="let store of store_list" [ngValue]="store.id">
							{{store.name | titlecase}}
						</option>
					</select>
					<div class="form-control" *ngIf="!rest.current_permission.global_purchases">
						{{purchase_info.store.name | titlecase }}
					</div>
				</div>
				<div class="col-12 col-md-6 col-lg-2 form-group">
					<label>Total</label>
					<div>{{purchase_info.bill.total}}</div>
				</div>
				<div class="col-12 col-md-6 col-lg-2 form-group">
					<label>Artículos</label>
					<div>{{total_items | number}}</div>
				</div>
				<div class="col-12 col-md-2">
					<label class="">Folio</label>
					<input name="folio" [(ngModel)]="purchase_info.bill.folio" class="form-control" type="text">
				</div>
				<div class="col-12 col-md-2">
					<label class="">Moneda</label>
					<select name="currency_id" [(ngModel)]="purchase_info.bill.currency_id" class="form-control" [disabled]="purchase_info.details.length > 0" required>
						<option *ngFor="let currency of currency_list" [value]="currency.id">{{currency.id}}</option>
					</select>
				</div>
				<div class="col-6 col-md-2">
					<app-attachment-uploader [(attachment_id)]="purchase_info.bill.receipt_attachment_id" [default_message]="'Recibo'" [btnClass]="'btn btn-primary w-100'"></app-attachment-uploader>
				</div>
				<div class="col-6 col-md-2">
					<app-attachment-uploader [(attachment_id)]="purchase_info.bill.invoice_attachment_id" [default_message]="'Pdf Factura'" [btnClass]="'btn btn-primary w-100'"></app-attachment-uploader>

					<div class="mt-2 d-grid gap-2 d-print-none" *ngIf="purchase_info.bill.invoice_attachment_id">
						<a [href]="rest.getFilePath(purchase_info.bill.invoice_attachment_id, true)" target="_blank" class="btn btn-primary w-100">
							<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" class="me-1"><path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-8.5 7.5c0 .83-.67 1.5-1.5 1.5H8v1.5H6.5V9H9c.83 0 1.5.67 1.5 1.5M19 12c0 .83-.67 1.5-1.5 1.5h-2V9h2c.83 0 1.5.67 1.5 1.5v1.5m-4.5-1.5v3H13v-3h-1.5V9H15v1.5h-2m-6 1.5H8v-1.5H7v1.5m10-1.5h1v1.5h-1v-1.5Z"/></svg>
							Ver PDF
						</a>
						<button type="button" class="btn btn-primary w-100" (click)="purchase_info.bill.invoice_attachment_id = null">
							<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" class="me-1"><path fill="currentColor" d="M19 4h-3.5l-1-1h-5l-1 1H5v2h14M6 19a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7H6v12Z"/></svg>
							Eliminar
						</button>
					</div>
				</div>
				<div class="col-6 col-md-2">
					<ng-container *ngIf="purchase_info.purchase.stock_status == 'PENDING' && purchase_info.bank_movements_info.length == 0">
						<app-attachment-uploader [(attachment_id)]="xml_attachment_id" [default_message]="'XML Factura'" [accept]="'.xml'" [btnClass]="'btn btn-primary w-100'" (attachmentChange)="onXmlAttachmentChange($event)"></app-attachment-uploader>
						<small class="text-muted" *ngIf="loading_cfdi">Procesando XML...</small>
					</ng-container>
					<div class="mt-2 d-grid gap-2 d-print-none" *ngIf="xml_attachment_id">
						<a [href]="rest.getFilePath(xml_attachment_id, true)" target="_blank" class="btn btn-primary w-100">
							<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" class="me-1"><path fill="currentColor" d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6m2 16H8v-2h8v2m0-4H8v-2h8v2m-3-5V3.5L18.5 9H13z"/></svg>
							Ver XML
						</a>
						<button type="button" class="btn btn-primary w-100" *ngIf="purchase_info.purchase.stock_status == 'PENDING' && purchase_info.bank_movements_info.length == 0" (click)="xml_attachment_id = null">
							<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" class="me-1"><path fill="currentColor" d="M19 4h-3.5l-1-1h-5l-1 1H5v2h14M6 19a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7H6v12Z"/></svg>
							Eliminar
						</button>
					</div>
				</div>
			</div>
		</div>

		<div class="card p-3 mt-3" *ngIf="purchase_info.purchase.stock_status == 'PENDING' && (purchase_info.bank_movements_info.length > 0 || purchase_info.bill?.id)">
			<h5>Pagos</h5>
			<div *ngIf="purchase_info.bank_movements_info.length > 0">
				<div class="table-responsive">
					<table class="table table-sm table-nowrap mb-0">
						<thead class="thead-light">
							<tr>
								<th>Tipo</th>
								<th>Monto</th>
								<th>Fecha</th>
								<th>Ref.</th>
								<th class="text-end">Acciones</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let bmi of purchase_info.bank_movements_info">
								<td>{{bmi.bank_movement.transaction_type | titlecase}}</td>
								<td>{{bmi.bank_movement.total | currency:'$'}}</td>
								<td>{{bmi.bank_movement.paid_date | date:'dd/MM/yyyy'}}</td>
								<td>{{bmi.bank_movement.reference || '---'}}</td>
								<td class="text-end">
									<a *ngIf="bmi.bank_movement.payment_id" [routerLink]="['/view-payment', bmi.bank_movement.payment_id]" class="btn btn-sm btn-primary">
										Ver Pago
									</a>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="mt-2">
					<strong>Total pagado: {{purchase_info.bill.amount_paid | currency:'$'}}</strong>
				</div>
			</div>
			<div *ngIf="purchase_info.bank_movements_info.length == 0 && purchase_info.bill?.id">
				<button type="button" class="btn btn-primary" (click)="openPaymentModal()">
					Agregar Pago
				</button>
			</div>
		</div>
		<div class="card p-3 mt-3">
			<!--div class="row" *ngIf="purchase_info.purchase.stock_status=='PENDING'">
				<div class="col-8 col-lg-10">
					<div class="mb-3 w-100">
						<app-search-items [(search_str)]="search_str" (item_selected)="onItemInfoSelect($event)"></app-search-items>
					</div>
				</div>
				<div class="col-4 col-lg-2 text-end">
					<button type="button" [disabled]="is_loading" class="btn btn-primary" (click)="showAddNewItem()" *ngIf="purchase_info.purchase.stock_status == 'PENDING' && purchase_info.bank_movements_info.length == 0">
						<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 16 16"><g fill="currentColor"><path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z"/></g></svg>
						Nuevo Artículo
					</button>
				</div>
			</div-->
			<div class="row fw-bold d-none d-md-flex pb-3 border-bottom mb-3">
				<div class="col-4">Artículo</div>
				<div class="col-3">Precio Unitario</div>
				<div class="col-2">Cantidad</div>
				<div class="col-2 text-end">Total con Imp.</div>
				<div class="col-1"></div>
			</div>
			<ng-container *ngFor="let pdi of purchase_info.details;let i=index">
				<div class="row my-1 border-bottom border-md-none pb-3 pb-md-1 mb-3 mb-md-1 align-items-center"
					*ngIf="pdi.purchase_detail.status != 'DELETED'">
					<div class="col-10 col-md-4 fw-bold">
						{{i+1}} -
						<img [src]="rest.getImagePath(pdi.item.image_id,pdi?.category?.image_id,rest.local_preferences.default_product_image_id)"
							style="height:44px;width:44px;">
						<span *ngIf="pdi?.category">{{pdi.category.name}} - </span>
						{{pdi.item.name}}
					</div>
					<div class="col-2 col-md-1 fw-bold flex-order-1 order-md-last text-end ms-auto">
						<button type="button" class="btn btn-primary" (click)="removeItem(pdi)" *ngIf="purchase_info.purchase.stock_status=='PENDING' && purchase_info.bank_movements_info.length == 0">
							<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><g fill="none"><path d="M21.5 6a1 1 0 0 1-.883.993L20.5 7h-.845l-1.231 12.52A2.75 2.75 0 0 1 15.687 22H8.313a2.75 2.75 0 0 1-2.737-2.48L4.345 7H3.5a1 1 0 0 1 0-2h5a3.5 3.5 0 1 1 7 0h5a1 1 0 0 1 1 1zm-7.25 3.25a.75.75 0 0 0-.743.648L13.5 10v7l.007.102a.75.75 0 0 0 1.486 0L15 17v-7l-.007-.102a.75.75 0 0 0-.743-.648zm-4.5 0a.75.75 0 0 0-.743.648L9 10v7l.007.102a.75.75 0 0 0 1.486 0L10.5 17v-7l-.007-.102a.75.75 0 0 0-.743-.648zM12 3.5A1.5 1.5 0 0 0 10.5 5h3A1.5 1.5 0 0 0 12 3.5z" fill="currentColor"/></g></svg>
						</button>
						<button type="button" class="btn btn-primary" (click)="clone(pdi)" *ngIf="pdi.item.has_serial_number=='YES'">
							<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 512 512"><path fill="currentColor" d="M464 0c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48H176c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h288M176 416c-44.112 0-80-35.888-80-80V128H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48v-48H176z"/></svg>
						</button>
						<button type="button" class="btn btn-primary" *ngIf="purchase_info.purchase.stock_status=='PENDING'"  (click)="showTaxesModal(pdi)" title="Impuestos">
							<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>
							<span *ngIf="pdi.taxes && pdi.taxes.length > 0" class="ms-1">{{pdi.taxes.length}}</span>
						</button>
					</div>
					<div class="col-12 col-md-3">
						<label class="">Precio Unitario</label>
						<div class="input-group">
							<input type="number" [name]="'subtotal'+pdi.item.id+'-'+i" [(ngModel)]="pdi.purchase_detail.unitary_price" step="any" min="0" (ngModelChange)="updateTotal()" class="form-control" [disabled]="purchase_info.purchase.stock_status!='PENDING' || purchase_info.bank_movements_info.length > 0" required>
							<button type="button" class="btn btn-secondary" (click)="showEditPriceModal(pdi)"
								*ngIf="purchase_info.purchase.stock_status != 'PENDING' && (rest.current_permission.add_purchases || rest.current_permission.edit_purchase_order_with_stock)" title="Editar precio">
								<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/></svg>
							</button>
						</div>
					</div>
					<div class="col-6 col-md-2" *ngIf="pdi.item.has_serial_number != 'YES'">
						<label class="">
							Cantidad
							<span>{{pdi.item.measurement_unit}}</span>
						</label>
						<div class="input-group">
							<input type="number" [name]="'qty'+pdi.item.id+'-'+i" min="0" [step]="pdi.item.partial_sale == 'NO'?'1':'any'"
								[(ngModel)]="pdi.purchase_detail.qty" class="form-control" (ngModelChange)="updateTotal()"
								[disabled]="purchase_info.purchase.stock_status!='PENDING' || purchase_info.bank_movements_info.length > 0" required>
							<button type="button" class="btn btn-secondary" (click)="showEditQtyModal(pdi)"
								*ngIf="purchase_info.purchase.stock_status != 'PENDING' && (rest.current_permission.add_purchases || rest.current_permission.edit_purchase_order_with_stock)" title="Editar cantidad">
								<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/></svg>
							</button>
						</div>
					</div>
					<div class="col-12 col-md-2" *ngIf="pdi.item.has_serial_number == 'YES'">
						<label class="">Número de Serie</label>
						<input type="text" [name]="'serial_number'+pdi.item.id+'-'+i"
							[(ngModel)]="pdi.purchase_detail.serial_number" class="form-control"
							(ngModelChange)="updateTotal()" [disabled]="purchase_info.purchase.stock_status!='PENDING' || purchase_info.bank_movements_info.length > 0"
							required>
					</div>
					<div class="col-6 col-md-2 text-end">
						<label class="">Total</label>
						<div class="form-control-plaintext fw-bold">{{((pdi.purchase_detail.unitary_price * pdi.purchase_detail.qty - (pdi.purchase_detail.discount || 0)) + getTaxesTotal(pdi)) | currency}}</div>
					</div>
					<!-- Display taxes if present -->
					<div class="col-2 offset-md-4 col-md-1" *ngIf="(pdi.taxes && pdi.taxes.length > 0) || (pdi.purchase_detail.discount)">
						<div class="d-flex flex-wrap mt-1">
							<small *ngFor="let tax of pdi.taxes" class="badge me-2 mb-1" [class.bg-light]="!tax.is_retention" [class.text-dark]="!tax.is_retention" [class.bg-danger]="tax.is_retention" [title]="tax.type">
								{{tax.name}}: {{tax.amount | currency}}
							</small>
							<small *ngIf="pdi.purchase_detail.discount" class="badge bg-warning text-dark me-2 mb-1">
								DESCUENTO: -{{pdi.purchase_detail.discount | currency}}
							</small>
						</div>
					</div>
				</div>
			</ng-container>
			<div class="row" *ngIf="purchase_info.purchase.stock_status=='PENDING' && purchase_info.bank_movements_info.length == 0 && rest.current_permission.add_purchases">
				<div class="col-8 col-lg-10">
					<div class="mb-3 w-100">
						<!--div class="dropdown">
							<input type="text" name="input_search" [(ngModel)]="input_search" (input)="onInput($event)" class="form-control" placeholder="Buscar Artículo" autocomplete="off">
							<ul class="dropdown-menu show w-100" *ngIf="item_info_list.length">
								<li *ngFor="let item_info of item_info_list" class="border-bottom">
									<button class="dropdown-item" (click)="onItemInfoSelect(item_info)">
										<img [src]="rest.getImagePath(item_info.item.image_id,item_info?.category?.image_id,rest.local_preferences.default_product_image_id)" style="height:44px;width:44px;">
										{{item_info?.category?.name}} {{item_info.item.name}}
									</button>
								</li>
							</ul>
						</div-->
						<app-search-items [(search_str)]="search_str" (item_selected)="onItemInfoSelect($event)" (no_results_found)="onNoResultsFound($event)"></app-search-items>
					</div>
				</div>
				<!--div class="col-4 col-lg-2 text-end">
					<button type="button" [disabled]="is_loading" class="btn btn-primary" (click)="showScanner()">
						<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 16 16"><g fill="currentColor"><path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z"/></g></svg>
					</button>
				</div-->
				<div class="col-4 col-lg-2 text-end">
					<button type="button" [disabled]="is_loading" class="btn btn-primary" (click)="showAddNewItem()" *ngIf="purchase_info.purchase.stock_status == 'PENDING' && purchase_info.bank_movements_info.length == 0">
						<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 16 16"><g fill="currentColor"><path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z"/></g></svg>
						Nuevo Artículo
					</button>
				</div>
			</div>

			<div class="text-end my-3" *ngIf="purchase_info.purchase.stock_status=='PENDING'">
				<button type="submit" [disabled]="is_loading || purchase_info.purchase.stock_status != 'PENDING' || purchase_info.bank_movements_info.length > 0" class="btn btn-primary">
					<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="1.3em" height="1.3em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 20 20"><path d="M15.173 2H4c-1.101 0-2 .9-2 2v12c0 1.1.899 2 2 2h12c1.101 0 2-.9 2-2V5.127L15.173 2zM14 8c0 .549-.45 1-1 1H7c-.55 0-1-.451-1-1V3h8v5zm-1-4h-2v4h2V4z" fill="currentColor"/></svg>
					Guardar
				</button>
			</div>
		</div>
	</form>
</div>

<app-modal [(show)]="show_add_new">
	<div class="p-3 overflow-scroll" style="max-height:95vh">
		<app-add-new-item-easy (newItem)="onItemInfoSelect($event)" [initial_barcode]="search_str"></app-add-new-item-easy>
	</div>
</app-modal>

<app-modal [show]="show_item_exists_modal" [closable]="false">
	<div class="p-3">
		<h2>El artículo ya existe en la orden</h2>
		<p>¿Deseas agregar uno más a la cantidad?</p>
		<div class="text-end">
			<button type="button" class="btn btn-secondary me-2" (click)="cancelAddExistingItem()">Cancelar</button>
			<button type="button" class="btn btn-primary" (click)="incrementExistingItem()">Agregar uno más</button>
		</div>
	</div>
</app-modal>

<!--dialog id="scanner_dialog">
	<app-scan-new-item (item_scanned)="onItemScannedAdd($event)"></app-scan-new-item>
	<button (click)="closeScannerDialog()">Close</button>
</dialog-->

<app-modal [(show)]="show_cfdi_modal">
	<div class="p-3" style="max-height:90vh; overflow-y:auto; min-width:70vw;">
		<h2>Artículos de la Factura XML</h2>
		<p class="text-muted">Revisa los artículos encontrados en el XML y su coincidencia con el inventario.</p>

		<table class="table table-striped table-sm">
			<thead>
				<tr>
					<th>Descripción XML</th>
					<th class="text-end">Cant.</th>
					<th class="text-end">P. Unit.</th>
					<th class="text-end">Subtotal</th>
					<th class="text-end" *ngIf="show_iva_column">IVA</th>
					<th class="text-end" *ngIf="show_ieps_column">IEPS</th>
					<th class="text-end" *ngIf="show_isr_column">ISR Ret.</th>
					<th class="text-end">Total c/Imp</th>
					<th>Artículo Coincidente</th>
					<th>Acciones</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let concepto of cfdi_conceptos">
					<td>
						<small>{{concepto.descripcion}}</small>
						<br>
						<span class="badge bg-secondary">{{concepto.unidad}}</span>
					</td>
					<td class="text-end">{{concepto.cantidad | number}}</td>
					<td class="text-end">{{concepto.valorUnitario | currency}}</td>
					<td class="text-end">{{concepto.importe | currency}}</td>
					<td class="text-end text-success" *ngIf="show_iva_column">{{concepto.totalIva | currency}}</td>
					<td class="text-end text-info" *ngIf="show_ieps_column">{{concepto.totalIeps | currency}}</td>
					<td class="text-end text-danger" *ngIf="show_isr_column">{{concepto.totalRetenciones | currency}}</td>
					<td class="text-end fw-bold">{{(concepto.importe + concepto.totalTraslados - concepto.totalRetenciones) | currency}}</td>
					<td>
						<div *ngIf="concepto.matched_item" class="d-flex align-items-center">
							<img [src]="rest.getImagePath(concepto.matched_item.item.image_id, concepto.matched_item?.category?.image_id, rest.local_preferences.default_product_image_id)"
								style="height:32px;width:32px;" class="me-2">
							<span>{{concepto.matched_item.item.name}}</span>
						</div>
						<div *ngIf="!concepto.matched_item" class="text-warning">
							<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>
							Sin coincidencia
						</div>
					</td>
					<td>
						<div class="btn-group btn-group-sm" *ngIf="concepto.matched_item">
							<button type="button" class="btn btn-danger" (click)="clearConceptoMatch(concepto)" title="Quitar coincidencia">
								<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
								Cambiar
							</button>
						</div>
						<div *ngIf="!concepto.matched_item" style="min-width:200px;">
							<app-search-items [(search_str)]="concepto.search_str" (item_selected)="selectItemForConcepto(concepto, $event)" [reset_on_search]="false"></app-search-items>
						</div>
					</td>
				</tr>
			</tbody>
			<tfoot class="table-dark">
				<tr>
					<th>TOTALES</th>
					<th class="text-end">{{getCfdiTotalCantidad() | number}}</th>
					<th></th>
					<th class="text-end">{{getCfdiTotalImporte() | currency}}</th>
					<th class="text-end text-success" *ngIf="show_iva_column">{{getCfdiTotalIva() | currency}}</th>
					<th class="text-end text-info" *ngIf="show_ieps_column">{{getCfdiTotalIeps() | currency}}</th>
					<th class="text-end text-danger" *ngIf="show_isr_column">{{getCfdiTotalRetenciones() | currency}}</th>
					<th class="text-end fw-bold">{{getCfdiTotalConImpuestos() | currency}}</th>
					<th colspan="2"></th>
				</tr>
			</tfoot>
		</table>

		<div class="row mt-3 align-items-center">
			<div class="col-4">
				<span class="badge bg-success me-2">{{getMatchedConceptosCount()}} coincidencias</span>
				<span class="badge bg-warning">{{getUnmatchedConceptosCount()}} sin coincidir</span>
			</div>
			<div class="col-4 text-center">
				<small class="text-muted">Total XML:</small>
				<strong class="ms-2">{{cfdi_total | currency}}</strong>
				<span class="ms-2" [class.text-success]="isCfdiTotalMatch()" [class.text-danger]="!isCfdiTotalMatch()">
					<svg *ngIf="isCfdiTotalMatch()" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
					<svg *ngIf="!isCfdiTotalMatch()" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>
				</span>
			</div>
			<div class="col-4 text-end">
				<button type="button" class="btn btn-secondary me-2" (click)="show_cfdi_modal = false">Cancelar</button>
				<button type="button" class="btn btn-primary" (click)="addConceptosToPurchase()" [disabled]="getMatchedConceptosCount() === 0">
					<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
					Agregar Artículos Coincidentes
				</button>
			</div>
		</div>
	</div>
</app-modal>

<app-modal [(show)]="show_xml_provider_modal" [closable]="false">
	<div class="p-3" style="min-width:450px;">
		<h4>Seleccionar Proveedor del XML</h4>
		<p>Emisor detectado: <b>{{cfdi_emisor.nombre}}</b><br>
		<small class="text-muted">RFC: {{cfdi_emisor.rfc}}</small></p>

		<div *ngIf="xml_providers.length > 0" class="mb-3">
			<h6>Proveedores coincidentes en el sistema:</h6>
			<div class="list-group">
				<button type="button" class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
					*ngFor="let user of xml_providers" (click)="selectXmlProvider(user)">
					<span>{{user.id}} - {{user.name | titlecase}}</span>
					<span class="badge bg-primary rounded-pill">Seleccionar</span>
				</button>
			</div>
		</div>

		<div *ngIf="xml_providers.length === 0" class="alert alert-warning">
			<svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" viewBox="0 0 24 24" class="me-2"><path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>
			No se encontraron proveedores con este nombre.
		</div>

		<div class="text-end mt-4">
			<button type="button" class="btn btn-secondary me-2" (click)="show_xml_provider_modal = false">Omitir y continuar</button>
			<button type="button" class="btn btn-primary me-2" (click)="quickSaveProvider()" *ngIf="rest.current_permission.add_providers" [disabled]="is_loading">
				<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" class="me-1"><path fill="currentColor" d="M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4s-4 1.79-4 4s1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>
				Registrar y Seleccionar
			</button>
			<button type="button" class="btn btn-primary" (click)="addNewProviderFromXml()">
				Utilizar solo para esta compra
			</button>
		</div>
	</div>
</app-modal>

<app-modal [(show)]="show_taxes_modal">
	<div class="p-3" style="min-width:60vw; max-height: 90vh; overflow-y: auto;">
		<h4 *ngIf="taxes_item">Impuestos de {{taxes_item.item.name}}</h4>
		<table class="table table-sm">
			<thead>
				<tr>
					<th>Nombre</th>
					<th>Tipo</th>
					<th>Retención</th>
					<th>Base</th>
					<th>Tasa/Cuota</th>
					<th>Importe</th>
					<th></th>
				</tr>
			</thead>
			<tbody *ngIf="taxes_item">
				<tr *ngFor="let tax of taxes_item.taxes; let i = index">
					<td>
						<input type="text" [(ngModel)]="tax.name" class="form-control form-control-sm" placeholder="IVA, IEPS, etc.">
					</td>
					<td>
						<select [(ngModel)]="tax.type" class="form-control form-control-sm">
							<option value="rate">Tasa</option>
							<option value="fixed">Cuota</option>
							<option value="exempt">Exento</option>
						</select>
					</td>
					<td>
						<select [(ngModel)]="tax.is_retention" class="form-control form-control-sm">
							<option [ngValue]="0">Traslado</option>
							<option [ngValue]="1">Retención</option>
						</select>
					</td>
					<td>
						<input type="number" [(ngModel)]="tax.base" (ngModelChange)="tax.amount = (tax.base || 0) * (tax.rate || 0); updateTotal()" class="form-control form-control-sm" step="any">
					</td>
					<td>
						<input type="number" [(ngModel)]="tax.rate" (ngModelChange)="tax.amount = (tax.base || 0) * (tax.rate || 0); updateTotal()" class="form-control form-control-sm" step="any">
					</td>
					<td>
						<input type="number" [(ngModel)]="tax.amount" (ngModelChange)="updateTotal()" class="form-control form-control-sm" step="any">
					</td>
					<td class="text-end">
						<button type="button" class="btn btn-sm btn-danger" (click)="removeTax(i)">
							<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
						</button>
					</td>
				</tr>
			</tbody>
			<tfoot>
				<tr>
					<td colspan="7">
						<button type="button" class="btn btn-sm btn-primary me-2" (click)="addTax()">
							<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
							Agregar Impuesto
						</button>
						<button type="button" class="btn btn-sm btn-primary me-1" (click)="addIva16()">
							+ IVA 16%
						</button>
						<button type="button" class="btn btn-sm btn-primary me-1" (click)="addIva8()">
							+ IVA 8%
						</button>
						<button type="button" class="btn btn-sm btn-primary me-1" (click)="addIeps8()">
							+ IEPS 8%
						</button>
						<button type="button" class="btn btn-sm btn-danger" (click)="addIsr125()">
							+ ISR 1.25%
						</button>
					</td>
				</tr>
			</tfoot>
		</table>
		<div class="row mt-3" *ngIf="taxes_item">
			<div class="col-4">
				<label class="form-label fw-bold">Descuento</label>
				<div class="input-group">
					<input type="number" [(ngModel)]="taxes_item.purchase_detail.discount" (ngModelChange)="updateTotal()" class="form-control" step="any" min="0" placeholder="0">
					<span class="input-group-text">-</span>
				</div>
			</div>
		</div>
		<div class="row mt-3 align-items-center" *ngIf="taxes_item">
			<div class="col-6">
				<strong>Total Impuestos: </strong>
				<span [class.text-danger]="getTaxesTotal(taxes_item) < 0" [class.text-success]="getTaxesTotal(taxes_item) > 0">
					{{getTaxesTotal(taxes_item) | currency}}
				</span>
			</div>
			<div class="col-6 text-end">
				<button type="button" class="btn btn-secondary me-2" (click)="show_taxes_modal = false">Cerrar</button>
			</div>
		</div>
	</div>
</app-modal>

<app-modal [(show)]="show_edit_price_modal">
	<div class="p-3" style="min-width:400px;">
		<h4>Editar Precio</h4>
		<div class="mb-3">
			<label class="form-label">Nuevo Precio Unitario</label>
			<input type="number" [(ngModel)]="edit_price_value" class="form-control" step="any" min="0">
		</div>
		<div class="text-end">
			<button type="button" class="btn btn-secondary me-2" (click)="show_edit_price_modal = false">Cancelar</button>
			<button type="button" class="btn btn-primary" (click)="saveEditedPrice()" [disabled]="is_loading">Guardar</button>
		</div>
	</div>
</app-modal>

<app-modal [(show)]="show_edit_qty_modal">
	<div class="p-3" style="min-width:400px;">
		<h4>Editar Cantidad</h4>
		<div class="mb-3">
			<label class="form-label">Nueva Cantidad</label>
			<input type="number" [(ngModel)]="edit_qty_value" class="form-control" [step]="edit_qty_item?.item?.partial_sale == 'NO' ? '1' : 'any'" min="0">
		</div>
		<div class="text-end">
			<button type="button" class="btn btn-secondary me-2" (click)="show_edit_qty_modal = false">Cancelar</button>
			<button type="button" class="btn btn-primary" (click)="saveEditedQty()" [disabled]="is_loading">Guardar</button>
		</div>
	</div>
</app-modal>

<app-modal [(show)]="show_edit_qty_batch_modal">
	<div class="p-3" style="min-width:600px;">
		<h4>
			{{edit_qty_is_increase ? 'Agregar' : 'Quitar'}} {{edit_qty_diff}} unidades
			<span *ngIf="edit_qty_item">- {{edit_qty_item.item.name}}</span>
		</h4>

		<!-- Existing batch records -->
		<div *ngIf="existing_batch_records.length > 0" class="mb-3">
			<h6>Lotes actuales en este artículo:</h6>
			<table class="table table-sm table-bordered">
				<thead class="table-light">
					<tr>
						<th *ngIf="edit_qty_item?.item?.batch_option === 'BATCH_ONLY' || edit_qty_item?.item?.batch_option === 'BATCH_AND_EXPIRATION'">Lote</th>
						<th *ngIf="edit_qty_item?.item?.batch_option === 'EXPIRATION_ONLY' || edit_qty_item?.item?.batch_option === 'BATCH_AND_EXPIRATION'">Fecha Caducidad</th>
						<th class="text-end">Cantidad</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let br of existing_batch_records">
						<td *ngIf="edit_qty_item?.item?.batch_option === 'BATCH_ONLY' || edit_qty_item?.item?.batch_option === 'BATCH_AND_EXPIRATION'">
							<strong>{{br.batch}}</strong>
						</td>
						<td *ngIf="edit_qty_item?.item?.batch_option === 'EXPIRATION_ONLY' || edit_qty_item?.item?.batch_option === 'BATCH_AND_EXPIRATION'">
							{{br.expiration_date}}
						</td>
						<td class="text-end">{{br.qty}}</td>
						<td class="text-center">
							<button type="button" class="btn btn-sm btn-primary" (click)="addBatchFromExisting(br)" [disabled]="getRemainingQtyToAssign() <= 0" title="Agregar este lote">
								<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<hr *ngIf="existing_batch_records.length > 0">

		<p class="text-muted">
			{{edit_qty_is_increase ? 'Especifica los lotes a agregar al inventario.' : 'Especifica de qué lotes se quitará el inventario.'}}
		</p>

		<table class="table table-sm">
			<thead>
				<tr>
					<th>Cantidad</th>
					<th *ngIf="edit_qty_item?.item?.batch_option === 'BATCH_ONLY' || edit_qty_item?.item?.batch_option === 'BATCH_AND_EXPIRATION'">Lote</th>
					<th *ngIf="edit_qty_item?.item?.batch_option === 'EXPIRATION_ONLY' || edit_qty_item?.item?.batch_option === 'BATCH_AND_EXPIRATION'">Fecha Caducidad</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let row of edit_qty_batch_rows; let i = index">
					<td>
						<input type="number" [(ngModel)]="row.qty" class="form-control form-control-sm" min="1" [step]="edit_qty_item?.item?.partial_sale == 'NO' ? '1' : 'any'">
					</td>
					<td *ngIf="edit_qty_item?.item?.batch_option === 'BATCH_ONLY' || edit_qty_item?.item?.batch_option === 'BATCH_AND_EXPIRATION'">
						<input type="text" [(ngModel)]="row.batch" class="form-control form-control-sm" placeholder="Código de lote">
					</td>
					<td *ngIf="edit_qty_item?.item?.batch_option === 'EXPIRATION_ONLY' || edit_qty_item?.item?.batch_option === 'BATCH_AND_EXPIRATION'">
						<input type="date" [(ngModel)]="row.expiration_date" class="form-control form-control-sm">
					</td>
					<td>
						<button type="button" class="btn btn-sm btn-danger" (click)="removeEditQtyBatchRow(i)" [disabled]="edit_qty_batch_rows.length <= 1">
							<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
						</button>
					</td>
				</tr>
			</tbody>
			<tfoot>
				<tr>
					<td colspan="4">
						<button type="button" class="btn btn-sm btn-primary" (click)="addEditQtyBatchRow()">
							<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
							Agregar fila
						</button>
					</td>
				</tr>
			</tfoot>
		</table>

		<div class="row mb-3">
			<div class="col">
				<span class="badge" [class.bg-success]="getTotalEditQtyBatch() === edit_qty_diff" [class.bg-danger]="getTotalEditQtyBatch() !== edit_qty_diff">
					Total: {{getTotalEditQtyBatch()}} / {{edit_qty_diff}}
				</span>
			</div>
		</div>

		<div class="text-end">
			<button type="button" class="btn btn-secondary me-2" (click)="cancelEditQtyBatch()">Cancelar</button>
			<button type="button" class="btn btn-primary" (click)="submitEditQtyBatch()" [disabled]="is_loading || getTotalEditQtyBatch() !== edit_qty_diff">Guardar</button>
		</div>
	</div>
</app-modal>

<app-modal [(show)]="show_payment_modal" [biggest_posible]="true">
	<app-pay-bills
		[bill_list]="billAsList()"
		[provider]="purchase_info.provider || null"
		[store_id]="purchase_info.purchase.store_id || null"
		(paymentCreated)="onPaymentCreated()">
	</app-pay-bills>
</app-modal>

<app-modal [(show)]="show_change_provider_modal">
	<div class="p-3" style="min-width:400px;">
		<h4>Cambiar Proveedor</h4>
		<div class="mb-3">
			<label class="form-label">Buscar proveedor</label>
			<input type="text" class="form-control" [(ngModel)]="change_provider_search"
				(ngModelChange)="searchProviderInModal($event)" placeholder="Escriba el nombre del proveedor">
		</div>
		<ul class="list-group">
			<li class="list-group-item list-group-item-action" *ngIf="change_provider_search && rest.current_permission.add_providers"
				(click)="addNewProviderFromModal(change_provider_search)" style="cursor:pointer;">
				<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
				Registrar Proveedor: <b>{{change_provider_search}}</b>
			</li>
			<li class="list-group-item list-group-item-action" *ngFor="let user of change_provider_list"
				(click)="selectProviderFromModal(user)" style="cursor:pointer;">
				{{user.id}} - {{user.name | titlecase}}
			</li>
		</ul>
		<div class="text-muted" *ngIf="change_provider_search && change_provider_list.length == 0 && !rest.current_permission.add_providers">
			No se encontraron proveedores
		</div>
		<div class="text-end mt-3">
			<button type="button" class="btn btn-secondary" (click)="show_change_provider_modal = false">Cancelar</button>
		</div>
	</div>
</app-modal>
